import { Injectable } from "@angular/core";
import { StreamId } from "@common/domain";
import {
  LocalConferenceStreamsListService,
  RemoteConferenceStreamsListService
} from "@youm-front/conference-stream/data-access";
import { combineLatest, map, Observable } from "rxjs";
import { ConferenceStream } from "youm-lib/conference";

@Injectable()
export class ConferenceStreamsListService {
  readonly cStreams$: Observable<ConferenceStream[]>;
  readonly cStreamsMap$: Observable<Map<StreamId, ConferenceStream>>;

  constructor(
    private readonly localConferenceStreamsListService: LocalConferenceStreamsListService,
    private readonly remoteConferenceStreamsListService: RemoteConferenceStreamsListService
  ) {
    this.cStreams$ = combineLatest([
      this.localConferenceStreamsListService.streams$,
      this.remoteConferenceStreamsListService.streams$
    ]).pipe(map((_) => [..._[0], ..._[1]]));

    this.cStreamsMap$ = this.cStreams$.pipe(
      map((_) =>
        _.reduce((acc, stream: ConferenceStream) => {
          return acc.set(stream.streamId as StreamId, stream);
        }, new Map<StreamId, ConferenceStream>())
      )
    );
  }
}
